import { isNumber } from 'lodash';
import React, { FC, useEffect, useRef, useState } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import { getMemberInfo } from 'src/utils/common';
import {
  errorModalViewStore,
  loadingModalViewStore,
  confirmModalViewStore,
  contentModalDep2ViewStore,
} from 'src/store/modal';
import { fetchInsertInsurfeeData, fetchUpdateInsurfeeData } from 'src/fetch/stepC/insurfee';
import { insurfeeDataStore } from 'src/store/insurfee';
// import { initCreditCardPayload } from 'src/store/creditcard';
import { addComma } from 'src/utils/common';
import {
  settlementNtsDataStore,
  ntsFileDataStore,
  settlementDataStore,
} from 'src/store/settlementInfo';
import InputBox from 'src/components/atoms/input/DefInputBox';
import DefaultButton from 'src/components/atoms/buttons/DefaultButton';
import DefLabel from 'src/components/atoms/label/LabelContnet';
import LabelSelect from 'src/components/atoms/selectbox/LabelSelect';
import CheckBox from 'src/components/atoms/CheckBox';
import HelpButton from 'src/components/atoms/buttons/HelpButton';
import Description from 'src/components/molecules/table/Description/Premium';

interface Props {
  data: any;
  type: string;
}
const GridAdd: FC<Props> = ({ data, type }) => {
  const userInfoData: any = getMemberInfo();
  const queryClient = useQueryClient();
  const errorModalState = errorModalViewStore((state: any) => state.set);
  const loadingState = loadingModalViewStore((state: any) => state.set);
  const setConfirmModalState = confirmModalViewStore((state: any) => state.set);
  const closeModalState = confirmModalViewStore((state: any) => state.close);
  const setContentModalState = contentModalDep2ViewStore((state: any) => state.set);

  const storeData = insurfeeDataStore((state: any) => state.result).data || [];
  const storeInitPayload = insurfeeDataStore((state: any) => state.initPayload);
  const storePayload = insurfeeDataStore((state: any) => state.payload);
  const storePayloadBind = insurfeeDataStore((state: any) => state.bindPayload);
  const bindStoreParam = insurfeeDataStore((state: any) => state.param);
  const bindStoreBindParam = insurfeeDataStore((state: any) => state.bindParam);

  // 정산결과
  const settlementBindParam = settlementDataStore((state: any) => state.bindParam);
  const settlementParam = settlementDataStore((state: any) => state.param);
  // 정산결과(NTS)
  const ntsInfoBindParam = settlementNtsDataStore((state: any) => state.bindParam);
  const ntsInfoParam = settlementNtsDataStore((state: any) => state.param);
  // NTS 업로드파일 데이터
  const ntsFileBindParam = ntsFileDataStore((state: any) => state.bindParam);
  const ntsFileParam = ntsFileDataStore((state: any) => state.param);

  useEffect(() => {
    if (type === 'insert') {
      storePayloadBind({ ...storeInitPayload });
    } else {
      const storeData = data.infoData;
      for (const key in storePayload) {
        storePayload[key] = storeData[key];
      }
      storePayloadBind({ ...storePayload });
    }
  }, [storeData]);

  const familyDataSet = storeData || [];
  // const familyDataSet = storeData.filter((item: any) => item.family_type === '1');

  const familySet = familyDataSet.map((item: any) => {
    return { id: item.family_seqid, value: item.name };
  });
  familySet.unshift({ id: '', value: '선택' });

  const checkedFamily =
    storePayload.family_seqid === 0
      ? familySet[0]
      : { id: storePayload.family_seqid, value: storePayload.name };
  const familySelect = {
    checked: checkedFamily,
    options: familySet,
  };

  const dataTypeOpt = [
    { id: 'G0001', value: '일반 보장성 보험' },
    { id: 'G0002', value: '장애인 전용 보장성 보험' },
  ];
  dataTypeOpt.unshift({ id: '', value: '선택' });

  const checkedType =
    storePayload.data_type === ''
      ? dataTypeOpt[0]
      : {
          id: storePayload.data_type,
          value: dataTypeOpt.find((item: any) => item.id === storePayload.data_type)?.value || '',
        };

  const selectType = {
    checked: checkedType,
    options: dataTypeOpt,
  };

  const help = {
    content: `
      <div className="_hint_content">
        <div className="_item">ㆍ보험료공제의 경우 계약자와 피보험자가 모두 기본공제 대상이어야만 합니다.</div>
        <div className="_item">ㆍ피보험자가 장애인이면서 장애인전용보장성보험인 경우에만 보험종류 중 장애인 보험을 선택하실 수 있습니다.</div>
        <div className="_item">ㆍ보험료는 피보험자 기준으로 등록됩니다.</div>
      </div>
      `,
    title: '내역 추가',
  };

  const confirmSelect = (item: any, field: string) => {
    console.log(item, field);
    if (field === 'family_seqid') {
      storePayloadBind({ ...storeInitPayload, family_seqid: item.id, name: item.value });
    } else {
      storePayload[field] = item.id;
      storePayloadBind({ ...storePayload });
    }
  };

  const confirmEvt = () => {
    console.log('confirmEvt', storePayload);
    storePayload.acct_year = userInfoData.acct_year;
    storePayload.co_cd = userInfoData.co_cd;
    storePayload.co_id = userInfoData.co_id;
    const param: any = storePayload;

    fetchInsertInsurfeeData(param, queryClient, errorModalState, loadingState, () => {
      const initialSeq = bindStoreParam.initialSeq || 0;
      bindStoreBindParam({ initialSeq: initialSeq + 1 });

      const initialSetSeq = settlementParam.initialSeq || 0;
      settlementBindParam({ initialSeq: initialSetSeq + 1 });
      const initialNtsSeq = ntsInfoParam.initialSeq || 0;
      ntsInfoBindParam({ initialSeq: initialNtsSeq + 1 });
      const initialFileSeq = ntsFileParam.initialSeq || 0;
      ntsFileBindParam({ initialSeq: initialFileSeq + 1 });

      setContentModalState({
        active: '',
      });
    });
  };

  // UPDATE
  const modifyEvt = () => {
    storePayload.acct_year = userInfoData.acct_year;
    storePayload.co_cd = userInfoData.co_cd;
    storePayload.co_id = userInfoData.co_id;
    const param: any = storePayload;
    // return false;
    fetchUpdateInsurfeeData(param, queryClient, errorModalState, loadingState, () => {
      const initialSeq = bindStoreParam.initialSeq || 0;
      bindStoreBindParam({ initialSeq: initialSeq + 1 });

      const initialSetSeq = settlementParam.initialSeq || 0;
      settlementBindParam({ initialSeq: initialSetSeq + 1 });
      const initialNtsSeq = ntsInfoParam.initialSeq || 0;
      ntsInfoBindParam({ initialSeq: initialNtsSeq + 1 });
      const initialFileSeq = ntsFileParam.initialSeq || 0;
      ntsFileBindParam({ initialSeq: initialFileSeq + 1 });

      setContentModalState({
        active: '',
      });
    });
  };

  const inpChangeEvt = (e: React.ChangeEvent<HTMLInputElement>, key: string) => {
    let chkValue = e.target?.value || '';
    chkValue = chkValue.replaceAll(',', '');
    const chkNum = Number(chkValue);
    if (chkNum || chkNum === 0) {
      storePayload[key] = chkNum;
      storePayloadBind({ ...storePayload });
    }
  };

  return (
    <div className="_add_insurfee_layout">
      {/* <div className="_desc_div">
        <div className="_main">총 급여의 25% : 10,000,000</div>
        <div className="_sub">신용카드등은 총급여의 25% 이상이어야 공제 가능합니다.</div>
      </div> */}
      <div className="_title_div">
        <div className="_title">내역</div>
        <div className="_help_div">
          <HelpButton content={help.content} title={help.title} styleDef={{ width: '680px' }} />
        </div>
      </div>
      <div className="_inp_div">
        <div className="_opt_div">
          <div className="_item" style={{ zIndex: 15, width: '400px' }}>
            {type === 'insert' ? (
              <LabelSelect
                label="피보험자"
                select={familySelect}
                labelStyle={{ width: '200px' }}
                boxStyleDef={{ width: 'calc(100% - 200px)' }}
                confirmEvent={confirmSelect}
                field="family_seqid"
              />
            ) : (
              <div className="_title_div">
                <DefLabel
                  label="부양가족 명"
                  content={storePayload.name || ''}
                  styleDef={{
                    color: '#333',
                    fontWeight: '600',
                    fontSize: '15px',
                    // paddingLeft: '10px',
                  }}
                  labelStyleDef={{
                    fontWeight: '500',
                    fontSize: '14px',
                    width: '207px',
                    // paddingRight: '10px',
                  }}
                />
              </div>
            )}
          </div>
          <div className="_item" style={{ zIndex: 10, width: '400px' }}>
            <LabelSelect
              label="구분"
              select={selectType}
              labelStyle={{ width: '200px' }}
              boxStyleDef={{ width: 'calc(100% - 120px)' }}
              confirmEvent={confirmSelect}
              field="data_type"
            />
          </div>
          <div className="_item" style={{ zIndex: 5, width: '400px' }}>
            <InputBox
              changeEvt={e => inpChangeEvt(e, 'htx_amt')}
              label="납부금액(국세청자료)"
              status={''}
              labelPosition="left"
              value={addComma(storePayload.htx_amt)}
              placeholder="값을 입력하세요"
              labelStyleDef={{ width: '200px', color: '#333', fontSize: '14px' }}
              inpStyleDef={{ textAlign: 'right' }}
            />
          </div>
          <div className="_item" style={{ zIndex: 5, width: '400px' }}>
            <InputBox
              changeEvt={e => inpChangeEvt(e, 'amt')}
              // inputRef={inpRef}
              label="납부금액(기타자료)"
              status={''}
              labelPosition="left"
              value={addComma(storePayload.amt)}
              placeholder="값을 입력하세요"
              labelStyleDef={{ width: '200px', color: '#333', fontSize: '14px' }}
              // styleDef={boxStyle}
              inpStyleDef={{ textAlign: 'right' }}
            />
          </div>
        </div>
      </div>
      <div className="_description">
        <Description />
      </div>
      <div className="_btn_div">
        {type === 'insert' ? (
          <DefaultButton
            text="내역 추가"
            styleDef={{ width: '250px' }}
            clickEvent={e => confirmEvt()}
            icon=""
            type="type5"
          />
        ) : (
          <DefaultButton
            text="내역 변경"
            styleDef={{ width: '250px' }}
            clickEvent={e => modifyEvt()}
            icon=""
            type="type3"
          />
        )}
      </div>
    </div>
  );
};

export default GridAdd;
